import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGFly from "../../../assets/img/Featured/fly-tap-pay-tall.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const OutdoorDiningPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page outdoorDiningPage">
            <Header />
            <div className="page-header">Healthcare Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Outdoor Dining</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Enhance outdoor dining with POS and mobile ordering 
                    solutions that deliver preference-driven convenience 
                    anywhere on property.{'\n\n'}
                </div>
                <div className="std-text">
                    Staff and visitors can order ahead or on-site for quick, accurate 
                    service, while operators gain real-time insights to 
                    optimize staffing, menus and flow. The result is a 
                    seamless, guest-centric experience that boosts 
                    satisfaction and operational efficiency in healthcare 
                    dining spaces.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Outdoor Dining", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Outdoor Dining", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Healthcare Dining - Outdoor Dining", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={IGFly} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default OutdoorDiningPage;